import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import styles from '../../pa_checklist_followup.module.scss';
import { usePAChecklistFollowUp } from '../../pa_checklist_followup_context';
import { toBrDateWithTime } from '../../../../../utils/dateUtils';
import Tabela from '../../../../Misc/Tabela/Tabela';
import { api } from '../../../../../services/api';
import { toast } from 'react-toastify';
import { generateHash } from '../../../../../utils/misc_utils';

function ReanaliseHistoricoModal() {
  const { showModalHistoricoReanalise, setShowModalHistoricoReanalise, isAdmin, usuarioAdminFup, historicoReanalise, itemSelecionado, pedirReanalise } = usePAChecklistFollowUp();

  const [historicoPrio, setHistoricoPrio] = useState(false);
  const [carregando, setCarregando] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        setCarregando(true);
        const res = await api.get('pa/checklist-fup/checklist-fup-historico-priorizacao', { params: { id_entrada_fiscal: itemSelecionado.id_entrada_fiscal } });
        setHistoricoPrio([...res.data]);
        setCarregando(false);
      } catch (e) {
        toast.error('Não foi possível carregar o histórico de alterações da produção, por favor tente novamente ou entre em contato com o suporte.')
      }
    })();
  }, []);

  const historicoColumns = [
    { name: 'Data', selector: row => toBrDateWithTime(row.data_registro), width: '160px' },
    { name: 'Usuário Responsável', selector: row => row.login, wrap: true },
    { name: 'Processo', selector: row => row.processo, wrap: true, width: '160px' },
    { name: 'Info', selector: row => row.informacao.split('\n').map((str => (<span key={`splt_${generateHash()}`}>{str}<br /></span>))), wrap: true, width: '280px' }
  ];

  return (
    <Modal
      show={showModalHistoricoReanalise}
      onHide={() => setShowModalHistoricoReanalise(false)}
      centered
      size="lg"
      backdropClassName={styles.backdrop_z_override}
    >
      <Modal.Header style={{ fontWeight: '500' }} closeButton>
        Histórico de Alterações
      </Modal.Header>
      <Modal.Body>
        <Tabela
          columns={historicoColumns}
          data={historicoPrio || []}
          paginationPerPage={10}
          highlightOnHover={true}
          backgroundColor={'#fff'}
          color={'#000'}
          pagination={false}
          pending={carregando}
        />
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant={'primary'}
            style={{ marginLeft: 'auto', marginTop: '13px', fontWeight: '500' }}
            onClick={async () => {
              setCarregando(true);
              const res = await api.get('pa/checklist-fup/checklist-fup-historico-priorizacao', { params: { id_entrada_fiscal: itemSelecionado.id_entrada_fiscal } });
              setHistoricoPrio([...res.data]);
              setCarregando(false);
            }}
          >
            Recarregar Listagem
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* <Button
          variant={'danger'}
          style={{ fontWeight: '500' }}
          onClick={() => pedirReanalise(101)}
          disabled={itemSelecionado.revisao_ok}
        >
          Pedir reanálise REVISÃO
        </Button>
        <Button
          variant={'danger'}
          style={{ fontWeight: '500' }}
          onClick={() => pedirReanalise(102)}
          disabled={itemSelecionado.checklist_ok || itemSelecionado.finalizacao_ok}
        >
          Pedir reanálise CHECKLIST
        </Button> */}
      </Modal.Footer>
    </Modal>
  );
}

export default ReanaliseHistoricoModal;
